import { Home, Phone, Mail, Globe } from "lucide-mui"
import React from "react"

const STYLES = {
  wrapper: "space-y-4",
  addressRow: "flex items-start gap-3",
  icon: "w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5",
  phoneRow: "flex items-center gap-3",
  phoneIcon: "w-5 h-5 text-gray-600 flex-shrink-0",
  emailRow: "flex items-center gap-3",
  emailIcon: "w-5 h-5 text-gray-600 flex-shrink-0",
  websiteRow: "flex items-center gap-3",
  websiteIcon: "w-5 h-5 text-gray-600 flex-shrink-0",
  link: "text-black no-underline hover:underline",
} as const

type ContactDetailsProps = {
  address?: string | null
  zipcode?: string | null
  city?: string | null
  country?: string | null
  phone?: string | null
  email?: string | null
  website?: string | null
}

export const formatWebsiteLabel = (website: string) => website.replace(/^https?:\/\//, "").replace(/\/$/, "")

const ContactDetails: React.FC<ContactDetailsProps> = ({ address, zipcode, city, country, phone, email, website }) => (
  <div className={STYLES.wrapper}>
    {!!address && (
      <div className={STYLES.addressRow} data-testid="public-venue-info-address">
        <Home className={STYLES.icon} />
        <div>
          <div>{address}</div>
          <div>
            {!!zipcode && <span>{zipcode} </span>}
            {city}
            {!!country && <>, {country}</>}
          </div>
        </div>
      </div>
    )}
    {!!phone && (
      <div className={STYLES.phoneRow} data-testid="public-venue-info-phone">
        <Phone className={STYLES.phoneIcon} />
        <a href={`tel:${phone}`} className={STYLES.link} data-testid="public-venue-info-phone-link">
          {phone}
        </a>
      </div>
    )}
    {!!email && (
      <div className={STYLES.emailRow} data-testid="public-venue-info-email">
        <Mail className={STYLES.emailIcon} />
        <a href={`mailto:${email}`} className={STYLES.link} data-testid="public-venue-info-email-link">
          {email}
        </a>
      </div>
    )}
    {!!website && (
      <div className={STYLES.websiteRow} data-testid="public-venue-info-website">
        <Globe className={STYLES.websiteIcon} />
        <a
          href={website}
          target="_blank"
          rel="noopener noreferrer"
          className={STYLES.link}
          data-testid="public-venue-info-website-link"
        >
          {formatWebsiteLabel(website)}
        </a>
      </div>
    )}
  </div>
)

export default ContactDetails
